import { __ } from "@wordpress/i18n";
import SbUtils from "../../Utils/SbUtils";
import Button from "../Common/Button";
import Header from "../Global/Header";
import SupportScreenContext from "../Context/SupportScreenContext";
import { useState } from "react";
import Input from "../Common/Input";
import ManageExportFeed from "./Settings/Sections/ManageExportFeed";

const SupportPage = ( { sbCustomizer, editorTopLoader, editorNotification, editorConfirmDialog, isPro, upsellModal, apis, noticeBar, noticeBarMemo} ) => {

    const [ searchTerm, setSearchTerm ] = useState( '' );
    const [ isExpanded, setIsExpanded ] = useState( false );

    const isSocialWallActive = sbCustomizer?.isSocialWallActive && sbCustomizer?.isSocialWallActive ? true : false;
    const socialWallLinks = sbCustomizer?.socialWallLinks ?? [];

    return (
        <SupportScreenContext.Provider
            value={{
                sbCustomizer,
                editorTopLoader,
                editorNotification,
                editorConfirmDialog,
                isPro,
                upsellModal,
                apis,
                noticeBarMemo,
                noticeBar,
                isSocialWallActive,
                socialWallLinks
            }}
        >
            <Header
                className='sb-dashboard-header'
                heading={ __( 'Support', 'sb-customizer' )}
                editorTopLoader={ editorTopLoader }
                topNoticeBar={noticeBar.topNoticeBar}
                setTopNoticeBar={ (e) => {
                    noticeBar.setTopNoticeBar(e)
                } }
            />

            <section className='sb-full-wrapper sb-fs sb-fs'>
                <section className='sb-small-wrapper'>
                    {
                        sbCustomizer?.adminNoticeContent !== null &&
                        <section className='sb-fs'
                        dangerouslySetInnerHTML={{__html: sbCustomizer?.adminNoticeContent }}></section>
                    }
                    <section className='sb-dashboard-heading sb-support-heading sb-fs'>
                        <h2 className='sb-h2'>{ __( 'Support', 'sb-customizer' ) }</h2>

                        <Input
                            size='medium'
                            customClass='sb-support-search'
                            leadingIcon='search'
                            disableleading-brd={true}
                            placeholder={ __( 'Search Documentation', 'sb-customizer' ) }
                            onKeyPress={ (event) => {
                                setSearchTerm( event.currentTarget.value )
                                if(event.key === 'Enter' && SbUtils.checkNotEmpty( searchTerm ) ){
                                    window.open( 'https://smashballoon.com/search/?search='+searchTerm+'&plugin=tiktok'  )
                                }
                            } }
                        />
                    </section>
                    <section className='sb-support-sections sb-fs'>
                        {
                            sbCustomizer?.supportContent &&
                            sbCustomizer?.supportContent.map( ( supportItem, key ) => {
                                return (
                                    <section className='sb-support-item sb-whitebox-ctn' key={key}>
                                        <div className='sb-support-item-icon sb-fs'>{ SbUtils.printIcon( supportItem?.icon ) }</div>
                                        <div className='sb-support-item-info sb-fs'>
                                            <h4 className='sb-h4 sb-dark-text sb-fs'>{ supportItem?.heading }</h4>
                                            <span className='sb-text-tiny sb-light-text2 sb-fs'>{ supportItem?.description }</span>
                                        </div>
                                        <div className='sb-support-item-links sb-fs'>
                                                {
                                                    supportItem?.content &&
                                                    supportItem?.content.map( ( link, linkKey ) => {
                                                        return (
                                                            <a
                                                                className='sb-support-item-link sb-dark-text sb-text-small '
                                                                href={ link.link }
                                                                target='_blank'
                                                                rel='noreferrer'
                                                                key={linkKey}
                                                            >
                                                                { link.text }
                                                            </a>
                                                        )
                                                    })
                                                }
                                        </div>
                                        {
                                            supportItem?.button &&
                                            <div className='sb-support-item-button'>
                                                <Button
                                                    type='secondary'
                                                    size='medium'
                                                    boxshadow={false}
                                                    text={supportItem?.button.text}
                                                    link={supportItem?.button.link}
                                                    target='_blank'
                                                    icon='chevron-right'
                                                    icon-position='right'
                                                    iconSize='8'
                                                    full-width={true}
                                                />
                                            </div>
                                        }


                                    </section>
                                )
                            })
                        }
                    </section>

                    <section className='sb-support-team-ctn sb-fs sb-whitebox-ctn'>
                        <div className='support-team-icon-ctn'>
                            { SbUtils.printIcon( 'comment', 'sb-support-team-icon' ) }
                        </div>
                        <div className='support-team-info'>
                            <h3 className='sb-dark-text sb-h3 sb-fs'>{ __( 'Need more support? We\'re here to help.', 'sb-customizer' ) }</h3>
                            <Button
                                type='brand'
                                size='medium'
                                boxshadow={false}
                                text={ __( 'Submit a Support Ticket', 'sb-customizer' ) }
                                link='https://smashballoon.com/support/'
                                target='_blank'
                                icon='chevron-right'
                                icon-position='right'
                                iconSize='8'
                            />
                        </div>
                        <div className='support-team-avatar'>
                            <img src={window.sb_customizer.assetsURL + 'sb-customizer/assets/images/support-team.jpg' } alt={ __( 'Amazing Support Team.', 'sb-customizer' ) } />
                            <span>{ __( 'Our fast and friendly support team is always happy to help!', 'sb-customizer' ) }</span>
                        </div>
                    </section>

                    <section className='sb-support-system-ctn sb-fs sb-whitebox-ctn'>
                        <div className='sb-support-system-section sb-fs'>
                            <div className='sb-support-system-top sb-fs'>
                                <h4 className='sb-h4'>{ __( 'System Info', 'sb-customizer' ) }</h4>
                                <Button
                                    type='secondary'
                                    size='medium'
                                    boxshadow={false}
                                    text={ __( 'Copy', 'sb-customizer' ) }
                                    icon='copy'
                                    icon-position='left'
                                    iconSize='12'
                                    onClick={ () => {
                                        SbUtils.copyToClipBoard( sbCustomizer.supportInfo.replaceAll('</br>', "\n"), editorNotification );
                                    } }
                                />
                            </div>
                            <div className='sb-support-system-info sb-fs'>
                                <div
                                    className='sb-support-system-content sb-fs'
                                    data-expanded={isExpanded}
                                    dangerouslySetInnerHTML={{__html:  sbCustomizer.supportInfo }}
                                >
                                </div>
                                <div
                                    className='sb-support-system-expand sb-fs sb-bold'
                                    onClick={ () => {
                                        setIsExpanded( !isExpanded )
                                    }}
                                >
                                    { SbUtils.printIcon(!isExpanded ?  'chevron-bottom' : 'chevron-top', 'sb-support-system-expand-icon', false, 10) }
                                    { isExpanded ? __( 'Collapse', 'sb-customizer' ) : __( 'Expand', 'sb-customizer' ) }
                                </div>
                            </div>
                        </div>

                        <div className='sb-support-system-section sb-support-system-export sb-fs'>
                            <div>
                                <strong className='sb-h4 sb-fs'>{ __( 'Export Settings', 'sb-customizer' ) }</strong>
                                <span className='sb-text-tiny sb-fs'>{ __( 'Share your plugin settings easily with Support', 'sb-customizer' ) }</span>
                            </div>
                            <div className='sb-support-system-export-inp'>
                                <ManageExportFeed />
                            </div>
                        </div>
                    </section>


                </section>
            </section>

        </SupportScreenContext.Provider>
    )

}

export default SupportPage;